import { LOCALE_ID, NgModule } from '@angular/core'
import { I18nService } from './services/i18n.service'
import { SvgIconService } from './services/svg-icon.service'
import { MomentTimeService } from './services/moment-time.service'
import { AngularSvgIconModule } from 'angular-svg-icon'

const PROVIDERS = [SvgIconService, MomentTimeService]

@NgModule({
  imports: [AngularSvgIconModule.forRoot()],
  providers: [
    ...PROVIDERS,
    {
      provide: LOCALE_ID,
      useFactory: (translate: I18nService) => {
        return translate.language
      },
      deps: [I18nService],
    },
  ],
})
export class CoreModule {}
